<template>
  <div :id="`modal_${uniqId}`" class="altapay-modal" aria-hidden="true">
    <div class="altapay-modal__overlay" tabindex="-1">
      <div class="altapay-modal__container" role="dialog" aria-modal="true" aria-labelledby="altapay-widget-modal-title">
        <header class="altapay-modal__header">
          <button class="altapay-modal__close" aria-label="Close modal" data-micromodal-close></button>
        </header>
        <div :id="`container_${uniqId}`"></div>
      </div>
    </div>
    <div class="altapay-modal__template">
      <div :id="`content_${uniqId}`" class="pw__wrapper">
        <div style="height: 100%; padding: 20px;">
          <header class="pw__header collapsible">
            <div class="common-info">
              <h2>{{ t('[altapay]Payment methods') }}</h2>
              <p class="amount"></p>
            </div>
            <div id="support-terminals" class="tabs"></div>
          </header>
          <section class="pw__content">
            <div id="payment-data"></div>
            <div class="loader">
              <div class="lds-dual-ring"></div>
            </div>
          </section>
        </div>
      </div>
      <div :id="`info_template_${uniqId}`">
        <section class="pw__info-block">
          <section class="text"></section>
          <section class="actions">
            <input class="actions__button" type="button" :value="t('[altapay]Continue')">
            <span class="actions__text">
                  <span class="custom-icon icon-lock"></span> {{ t('[altapay]Payments are secured and encrypted') }}
              </span>
          </section>
        </section>
      </div>
      <div :id="`success_template_${uniqId}`">
        <section class="pw__info-block">
          <section class="text"></section>
          <section class="actions">
            <input class="actions__button" type="button" :value="t('[altapay]Continue')">
          </section>
        </section>
      </div>
      <div :id="`error_template_${uniqId}`">
        <section class="pw__info-block">
          <section class="text">{{ t('[altapay]Unfortunately, an error occurred while executing a request to the server. We are already working on it.') }}</section>
          <section class="actions">
            <input class="actions__button" type="button" :value="t('[altapay]Try again')">
          </section>
        </section>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import PaymentCore from '../vendor/payment/PaymentCore';
import { resultHandler, vippsOrderIdHandler } from '../vendor/payment/result-handler';
import BaseComponent from './Base';

declare var saleData: any;

@Component
export default class AltapayModal extends BaseComponent {
  protected widget: PaymentCore;

  public open(amount: number, orderId: string, tid: string | null = null, description: object = {}, terminal: string | null = null) {
    this.widget.open(amount, orderId, tid, description, terminal);
  }

  protected mounted(): void {
    let response: any = null;
    this.widget = new PaymentCore({
      ...saleData,
      api: saleData.paymentApi,
      modalId: `modal_${this.uniqId}`,
      container: `#container_${this.uniqId}`,
      template: `#content_${this.uniqId}`,
      infoBlockTemplate: `#info_template_${this.uniqId}`,
      successTemplate: `#success_template_${this.uniqId}`,
      errorTemplate: `#error_template_${this.uniqId}`,
      onSuccess: (data) => {
        response = data;
      },
      onFail: (data) => {
        response = data;
      },
      onClose: ({ isCompleted }) => {
        if (isCompleted && response !== null) {
          resultHandler(response, 'success');
        }
      },
      beforeRegisterIntent: (data) => {
        vippsOrderIdHandler(data);

        return data;
      },
    });
  }
}
</script>
